module.exports = __webpack_public_path__ + "static/media/Ellipse-gold.d8f029aa.svg";